export const DATE_FORMATS = {
    s: 'YYYY-MM-DD HH:mm:ss',
    m: 'YYYY-MM-DD HH:mm',
    H: 'YYYY-MM-DD HH',
    D: 'YYYY-MM-DD',
    M: 'YYYY-MM',
    W: 'YYYY-wo',
    Q: 'YYYY-[Q]Q',
    Y: 'YYYY',
    HH: 'HH',
    Hm: 'HH:mm',
    Hms: 'HH:mm:ss',
};
export const NUMBER_COMPACT = [
    {
        compact: '千',
        conversion: 1000,
    },
    {
        compact: '万',
        conversion: 10000,
    },
    {
        compact: '百万',
        conversion: 1000000,
    },
    {
        compact: '千万',
        conversion: 10000000,
    },
    {
        compact: '亿',
        conversion: 100000000,
    },
    {
        compact: '万亿',
        conversion: 1000000000000,
    },
];
